<template v-if="widgetReady">
    <ac-modal :title="modalTitle" :size-class="'modal-lg'" ref="modalRef">
        <template>
            <div style="padding: 0px 15px;">
                <div class="row">
                    <div class="col-lg-4 form-group col-left">
                        <label style="width: 100%">
                            First Name
                            <small class="redText">required</small>
                            <input type="text" name="firstName" class="form-control" placeholder="First Name"
                                v-model="vm.contactInfo.firstName">
                        </label>
                    </div>
                    <div class="col-lg-4 form-group col-left">
                        <label style="width: 100%">
                            Middle Initial
                            <input type="text" name="middleInitial" class="form-control" maxlength="1"
                                placeholder="Middle Initial" v-model="vm.contactInfo.middleInitial">
                        </label>
                    </div>
                    <div class="col-lg-4 form-group col-left">
                        <label style="width: 100%">
                            Last Name
                            <small class="redText">required</small>
                            <input type="text" name="lastName" class="form-control" placeholder="Last Name"
                                v-model="vm.contactInfo.lastName">
                        </label>
                    </div>
                    <div class="col-lg-4 form-group col-left">
                        <label style="width: 100%" v-if="relationships.length > 0">
                            Relationship
                            <small class="redText">required</small>
                            <select v-model="vm.relationshipToPrimary" type="text" class="form-control">
                                <option value="" disabled>Select One</option>
                                <option :disabled="relationship.disabled" v-for="relationship in relationships"
                                    :value="relationship.relationshipsEnum">
                                    {{ relationship.relationType }}
                                </option>
                            </select>
                        </label>
                    </div>
                    <div class="col-lg-4 form-group col-left">
                        <label style="width: 100%" v-if="genders.length > 0">
                            Gender
                            <small class="redText">required</small>
                            <select v-model="vm.contactInfo.genderCode" type="text" class="form-control">
                                <option value="" disabled>Select One</option>
                                <option v-for="gender in genders" :value="gender.genderCode">
                                    {{ gender.genderName }}
                                </option>
                            </select>
                        </label>
                    </div>
                    <div class="col-lg-4 form-group col-left">
                        <label>
                            DOB
                            <small class="redText">required</small>
                        </label><br />
                        <ac-date-picker v-model="vm.birthDate"></ac-date-picker>
                    </div>
                    <div v-if="ssnRequired" class="col-lg-4 form-group col-left">
                        <label>
                            Social Security Number
                            <small class="redText">required</small>
                        </label>
                        <ac-social-security-number v-model="vm.ssn"></ac-social-security-number>
                    </div>
                    <div class="col-lg-4 form-group col-left">
                        <label>
                            Coverage Start Date
                            <small class="redText">required</small>
                        </label><br />
                        <ac-date-picker v-model="vm.effStartDate" :useTodayAsDefault="true" v-if="!futureCoverage"></ac-date-picker>
                        <input v-else type="text" class="form-control" :disabled="true" v-model="vm.effStartDate" />
                    </div>
                </div>
            </div>            
            <div class="row">
                <div class="col-md-12" style="text-align: right;">
                    <ac-button class="btn-sm btn-red wl-btn-failure button-size" :action="closeModal">
                        CANCEL
                    </ac-button>

                    <ac-button class="btn-sm btn-success wl-btn-success button-size" :action="saveDependent">
                        SUBMIT
                    </ac-button>
                </div>
            </div>            
        </template>
    </ac-modal>
</template>
  
<script>
import { mapGetters } from "vuex";
import { api } from "@/global/framework/api.js";
import { notifications } from "@/global/notifications.js";
import { common } from "@/global/common.js";
import { configTables } from "@/global/configTables.js";
import { formatter } from "../../../global/formatter.js";

export default {
    name: "AddDependentsModal",
    components: {},
    data() {
        return {
            model: { family: [], fullName: '', consumerId: 0 },
            vm: {
                contactInfo: { genderCode: '' },
                relationshipToPrimary: '',     
                company: { companyId: 0 }
            },
            employeeData: {},
            genders: [],
            relationships: [],
            coverageTypes: [],
            existingDependents: [],
            futureEffectiveDate:{},
            widgetReady: false,
            allowAddDependents: false
        }
    },
    computed: {
        ...mapGetters({ssnRequired: "globalSettings/ssnRequired"}),
        modalTitle() {
            return `Add Member`;
        },
        futureCoverage() {
            return this.employeeData.future && this.employeeData.future.consumerCoverageId > 0;
        },
    },
    methods: {
        async showModal({family: family, consumerId: consumerId, fullName: fullName }) {
            this.model = { family, consumerId, fullName };
            this.existingDependents = family.filter(member => member.isDependent && member.effEndDate == null);

            let employeeData = await api.get("Consumer", consumerId, "GetEditEmployeeModel");
            this.vm.effStartDate = (employeeData.future && employeeData.future.consumerCoverageId > 0)
                   ? new Date(employeeData.future.effectiveDate).toLocaleDateString() : formatter.getDateForDatePicker();

            this.mapData('employeeData', employeeData);

            if (this.existingDependents.some(dependent => dependent.relationshipToPrimary === 2)) {
                this.existingDependents.sort((a, b) => {
                    if (a.relationshipToPrimary === 2) return -1;
                    if (b.relationshipToPrimary === 2) return 1;
                    return 0;
                })
            }
            this.widgetReady = true;
            this.$refs.modalRef.open();
        },
        closeModal() {
            this.$emit("modal-closed");
            this.$refs.modalRef.close();
        },
        async saveDependent() {
            this.vm.primaryId = this.model.consumerId;      
            this.vm.company.companyId = this.employeeData.companyId;     
            let result = await api.postWithId('Consumer', this.model.consumerId, `CreateDependent`, this.vm);
            if(result)
            {
                this.$store.dispatch('LOAD_FAMILY_MEMBERS_PLAN_INFO', this.vm.primaryId);
                this.$store.dispatch('LOAD_FAMILY_MEMBERS', this.vm.primaryId);
                this.$store.dispatch('LOAD_SHOPPING_CART_SUMMARYS', this.vm.primaryId);
            }
            this.closeModal();
        }
    },
    async mounted() {
        let [g, r, c] = await Promise.all([
            configTables.getGenders(),
            configTables.getRelationshipsToPrimary(),
            configTables.getCoverageOptions()
        ])
        this.genders = g;
        this.relationships = r;
        this.coverageTypes = c;
    },
}
</script>

<style scoped>
button[disabled],
button[disabled]:hover,
button[disabled]:focus {
    opacity: .5;
}

.button-size {
    min-width: 75px;
}

.table {
    width: 100%;
    color: #212529;
    border-collapse: collapse;
}

.table th,
.table td {
    vertical-align: top;
    border-top: 1px solid #dee2e6;
}

.table th {
    font-weight: 600;
    padding: 0.25rem;
    background-color: #D9EDF7;
    border-top: 2px solid #dee2e6;
}

.redText {
    font-size: .7rem;
}

.form-group{
    padding: 5px;
}
</style>